import React, { useState } from 'react';

export default function Hero() {
  const [showGallery, setShowGallery] = useState(false);

  const galleryImages = [
    { id: 1, url: 'https://images.unsplash.com/photo-1599839619722-39751411ea63?q=80&w=600&auto=format&fit=crop', alt: 'Badminton Court' },
    { id: 2, url: 'https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?q=80&w=600&auto=format&fit=crop', alt: 'Cricket' },
    { id: 3, url: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=600&auto=format&fit=crop', alt: 'Gym Equipment' },
    { id: 4, url: 'https://images.pexels.com/photos/6164039/pexels-photo-6164039.jpeg?q=80&w=600&auto=format&fit=crop', alt: 'Fitness' }
  ];

  return (
    <section id="hero" className="hero">
      <h1 style={{ letterSpacing: '1px', textTransform: 'uppercase', fontFamily: 'Italic' }}>Welcome to Rudra Sports</h1>
      <p style={{ fontWeight: '300', letterSpacing: '0.5px' }}>Premium Badminton Courts • Box Cricket Arena • Modern Gym</p>

      <div className="cta-buttons">
        <a href="https://playo.co/venues/hyderabad/rudra-sports-arena-neredmet-hyderabad" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
          📱 Book via Playo
        </a>
        <button
          onClick={() => setShowGallery(true)}
          className="btn btn-secondary"
        >
          🖼️ View Gallery
        </button>
        <div
          onClick={() => { const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
          className="btn btn-secondary"
          style={{ cursor: 'pointer' }}
        >
          📞 Contact Us
        </div>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1.5rem',
        marginTop: '4rem',
        maxWidth: '1000px',
        width: '100%'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '2rem',
          borderRadius: '12px',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          transition: 'transform 0.3s ease',
          cursor: 'default'
        }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
          <div style={{ fontSize: '3rem', marginBottom: '0.8rem' }}>🏸</div>
          <h3 style={{ marginBottom: '0.5rem', fontSize: '1.4rem' }}>Badminton</h3>
          <p style={{ fontSize: '1rem', opacity: 0.9 }}>4 Professional Courts with LED Lighting</p>
        </div>

        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '2rem',
          borderRadius: '12px',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          transition: 'transform 0.3s ease',
          cursor: 'default'
        }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
          <div style={{ fontSize: '3rem', marginBottom: '0.8rem' }}>🏏</div>
          <h3 style={{ marginBottom: '0.5rem', fontSize: '1.4rem' }}>Box Cricket</h3>
          <p style={{ fontSize: '1rem', opacity: 0.9 }}>Indoor Arena with Synthetic Pitch</p>
        </div>

        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '2rem',
          borderRadius: '12px',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          transition: 'transform 0.3s ease',
          cursor: 'default'
        }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
          <div style={{ fontSize: '3rem', marginBottom: '0.8rem' }}>💪</div>
          <h3 style={{ marginBottom: '0.5rem', fontSize: '1.4rem' }}>Gym</h3>
          <p style={{ fontSize: '1rem', opacity: 0.9 }}>Fully Equipped with Modern Equipment</p>
        </div>
      </div>

      {/* Gallery Modal */}
      {showGallery && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '2rem'
        }}>
          <button
            onClick={() => setShowGallery(false)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '30px',
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '2rem',
              cursor: 'pointer',
              zIndex: 10000
            }}
          >
            ✕
          </button>

          <h2 style={{ color: 'white', marginBottom: '2rem', fontSize: '2rem' }}>Facility Gallery</h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '1.5rem',
            maxWidth: '1200px',
            width: '100%',
            maxHeight: '80vh',
            overflowY: 'auto',
            padding: '1rem'
          }}>
            {galleryImages.map(img => (
              <div key={img.id} style={{
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                aspectRatio: '4/3'
              }}>
                <img
                  src={img.url}
                  alt={img.alt}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
